var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader",style:({margin: _vm.margin+ ' auto'})},[_c('div',{staticClass:"circ1"}),_c('div',{staticClass:"circ2"}),_c('div',{staticClass:"circ3"}),_c('div',{staticClass:"circ4"})])
}
var staticRenderFns = []

export { render, staticRenderFns }